/*jshint esversion: 9 */


const Tracker = {
    // Pixels do Meta presentes na página (plataforma + produtor + evento).
    pixels: [],
    ready: false,
    // Eventos espelhados para a Conversions API via endpoint first-party (/cx),
    // pois NÃO têm gêmeo server-side próprio. AddToCart, InitiateCheckout e
    // Purchase já têm CAPI nos seus fluxos e não são reenviados aqui.
    capiEvents: ['PageView', 'ViewContent', 'AddPaymentInfo'],
    customToPixel: {
        'view_content': 'ViewContent',
        'initiate_checkout': 'InitiateCheckout',
        'purchase_success': 'Purchase',
        'payment_started': 'AddPaymentInfo',
        'add_to_cart': 'AddToCart',
        'delete_from_cart': 'RemoveFromCart',
    },
    customToAnalytics: {
        'view_content': 'view_item',
        'initiate_checkout': 'begin_checkout',
        'purchase_success': 'purchase',
        'payment_started': 'add_payment_info',
        'add_to_cart': 'add_to_cart',
        'delete_from_cart': 'remove_from_cart',
    },
    init: function () {
        if (typeof window.fbq === 'undefined') {
            return this;
        }
        // Idempotente: cada nível de pixel chama init(), mas só uma vez disparamos
        // PageView/trackerReady (senão duplicaria eventos no client).
        if (this.ready) {
            return this;
        }
        this.ready = true;
        const self = this;
        // setTimeout(0): espera TODOS os níveis registrarem seus pixels (todos os
        // registerPixel rodam no mesmo tick do alpine:init) antes de disparar.
        const start = function () {
            setTimeout(function () {
                self.ensureFbp();
                self.pageView();
                window.dispatchEvent(new CustomEvent('trackerReady'));
            }, 0);
        };
        // Página de borda: o event_id do Meta (window.fbeid) chega do beacon; o PageView só dispara depois (dedup com a CAPI).
        if (window.__edgeReady) {
            window.__edgeReady.then(start, start);
        } else {
            start();
        }
        return this;
    },
    // Garante o cookie _fbp first-party. Se o fbevents.js estiver bloqueado
    // (ad-block/iOS), a Meta não cria o _fbp — então criamos nós, no nosso
    // domínio, para a CAPI ter o fbp e atribuir a conversão.
    ensureFbp: function () {
        try {
            if (document.cookie.indexOf('_fbp=') !== -1) {
                return; // já existe (criado pela Meta ou por nós)
            }
            const value = 'fb.1.' + Date.now() + '.' + Math.floor(Math.random() * 1e10);
            const d = new Date();
            d.setTime(d.getTime() + 90 * 24 * 60 * 60 * 1000); // 90 dias
            document.cookie = '_fbp=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
        } catch (e) {
            // nunca quebrar a página por causa de tracking
        }
    },
    registerPixel: function (id) {
        if (!id || typeof window.fbq === 'undefined') {
            return this;
        }
        id = String(id);
        if (this.pixels.some(function (p) { return p.id === id; })) {
            return this; // evita registrar o mesmo pixel duas vezes
        }
        this.pixels.push({id: id});
        return this;
    },
    // Compat com a assinatura antiga. No-op seguro.
    registerPixelEvents: function () {
        return this;
    },
    // PageView: dispara uma vez por pixel (trackSingle) com event_id compartilhado
    // e espelha para a CAPI (server-side) com o mesmo id, para dedup.
    // Lista de pixels da página, montada no parse (window.trirsPixels) por cada
    // fbq('init'). Garante que conhecemos TODOS os pixels antes de qualquer disparo.
    getPixels: function () {
        return Array.isArray(window.trirsPixels) ? window.trirsPixels : [];
    },
    pageView: function () {
        if (typeof window.fbq === 'undefined') {
            return;
        }
        const eventId = 'PageView' + window.fbeid;
        this.fire('PageView', {}, eventId);
        this.capi('PageView', eventId, {});
    },
    // Dispara o evento para TODOS os pixels da página. Usa trackSingle por pixel
    // (entrega garantida, sem a corrida do broadcast com múltiplos pixels);
    // se a lista estiver vazia, cai no broadcast como fallback.
    fire: function (metaEvent, payload, eventId) {
        const opts = {eventID: eventId};
        const pixels = this.getPixels();
        if (pixels.length) {
            pixels.forEach(function (id) {
                window.fbq('trackSingle', id, metaEvent, payload, opts);
            });
        } else {
            window.fbq('track', metaEvent, payload, opts);
        }
    },
    pixel: function (event, data = {}) {
        if (typeof window.fbq === 'undefined') {
            return;
        }

        const metaEvent = this.customToPixel[event];
        if (typeof metaEvent === 'undefined') {
            console.error('Tracker pixel event not found', event);
            return;
        }

        // event_id explícito (ex.: Purchase + payment_id) casa com a CAPI;
        // default: nome do evento + fbeid da página.
        const payload = Object.assign({}, data);
        const eventId = payload.event_id ? payload.event_id : (metaEvent + window.fbeid);
        delete payload.event_id;

        // trackSingle por pixel -> garante que o produtor SEMPRE recebe.
        this.fire(metaEvent, payload, eventId);
    },

    track: function (event, data = {}) {
        const metaEvent = this.customToPixel[event];

        // capiEvents precisam de um event_id próprio, compartilhado entre o fbq e o
        // endpoint server-side, para a Meta deduplicar.
        if (metaEvent && this.capiEvents.indexOf(metaEvent) !== -1 && !data.event_id) {
            data = Object.assign({}, data, {event_id: metaEvent + '.' + this.genId()});
        }

        this.pixel(event, data);
        this.analytics(event, data);

        if (metaEvent && this.capiEvents.indexOf(metaEvent) !== -1) {
            this.capi(metaEvent, data.event_id, data);
        }
    },
    analytics: function (event, data = {}) {
        if (typeof window.dataLayer === 'undefined') {
            return;
        }

        const gaEvent = this.customToAnalytics[event];
        if (typeof gaEvent === 'undefined') {
            console.error('Tracker analytics event not found', event);
            return;
        }

        const payload = Object.assign({}, data);
        delete payload.event_id; // chave de controle interna, não enviar ao GA

        if (typeof gtag === 'function') {
            gtag('event', gaEvent, payload);
        } else {
            window.dataLayer.push(Object.assign({event: gaEvent}, payload));
        }
    },
    // Espelha o evento para a Conversions API (server-side, first-party /cx).
    // Como é o nosso domínio, ad-blockers/iOS não bloqueiam -> chega à Meta.
    capi: function (eventName, eventId, data) {
        try {
            const meta = document.querySelector('meta[name="csrf-token"]');
            if (!meta || !eventId) {
                return;
            }

            const body = {event_name: eventName, event_id: eventId};
            if (data) {
                if (data.value !== undefined && data.value !== null) {
                    body.value = data.value;
                }
                if (data.currency) {
                    body.currency = data.currency;
                }
                if (Array.isArray(data.content_ids)) {
                    body.content_ids = data.content_ids;
                }
            }
            if (window.trackerEventRef) {
                body.event_ref = window.trackerEventRef;
            }

            fetch('/cx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': meta.getAttribute('content'),
                },
                body: JSON.stringify(body),
                keepalive: true,
                credentials: 'same-origin',
            }).catch(function () {});
        } catch (e) {
            // tracking nunca deve quebrar a página
        }
    },
    genId: function () {
        return Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
    },
};

window.Tracker = Tracker;
